import React from 'react';
import { DeliveryZoneAndMapLayerZone } from 'domains/cartography';
import { useMount } from 'hooks';
import { Layout } from './components';
import { CurrencySymbol } from 'models';

export type ZoneModalProps = {
  deliveryZoneAndMapLayerZone: DeliveryZoneAndMapLayerZone | null;
  open: boolean;
  onClose: () => void;
  currency: CurrencySymbol;
};

const ZoneModal = (props: ZoneModalProps) => {
  const { mounted } = useMount({ isOpened: props.open });

  if (!mounted) return null;

  return <Layout {...props} />;
};

export default ZoneModal;
